var _style, _rect, _ellipse, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluorescentOutputLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "16.3px",
    height: "16.1px",
    viewBox: "0 0 16.3 16.1",
    style: {
      enableBackground: "new 0 0 16.3 16.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fluorescent Output Line") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5,
    className: "st0",
    width: 5.2,
    height: 6
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 2.9,
    cy: 8.1,
    rx: 0.8,
    ry: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 5,
    className: "st0",
    width: 5.2,
    height: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7,
    y: 5,
    className: "st0",
    width: 5.2,
    height: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluorescentOutputLine);
export default __webpack_public_path__ + "static/media/FluorescentOutputLine.ef73b5b57502b30bba8f0feeeb37b016.svg";
export { ForwardRef as ReactComponent };